import { render, staticRenderFns } from "./foot-switch.vue?vue&type=template&id=29789eb1&"
import script from "./foot-switch.vue?vue&type=script&lang=js&"
export * from "./foot-switch.vue?vue&type=script&lang=js&"
import style0 from "./foot-switch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSlideXTransition } from 'vuetify/lib'
installComponents(component, {
  VSlideXTransition,
})
